import { create } from 'zustand';
import { Connection } from './schema';

type ConnectionsDialogType = 'create' | 'update' | 'delete' | 'connect'

type ConnectionState = {
  open: ConnectionsDialogType | null;
  current: Connection | null;
  qrCodeBase64: string | null;
};

type ConnectionActions = {
  setQrCodeBase64: (data: ConnectionState['qrCodeBase64']) => void;
  setOpen: (data: ConnectionState['open']) => void
  setCurrent: (data: ConnectionState['current']) => void
};

type ConnectionStore = ConnectionState & ConnectionActions;

export const useConnectionStore = create<ConnectionStore>((set) => ({
  open: null,
  current: null,
  qrCodeBase64: null,

  setQrCodeBase64(data) {
    set((state) => ({ ...state, qrCodeBase64: data }))
  },
  setOpen(data) {
    set((state) => ({ ...state, open: data === state.open ? null : data }))
  },
  setCurrent(data) {
    set((state) => ({ ...state, current: data }))
  },
}));

export const selectQrCode = (state: ConnectionState) => state.qrCodeBase64;
export const selectSetQrCode = (state: ConnectionActions) => state.setQrCodeBase64;
export const selectOpen = (state: ConnectionState) => state.open;
export const selectSetOpen = (state: ConnectionActions) => state.setOpen;
export const selectCurrent = (state: ConnectionState) => state.current;
export const selectSetCurrent = (state: ConnectionActions) => state.setCurrent;